import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import dynamic from 'next/dynamic';
import { useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { HomePageIcon, HomePageFilledIcon, FeedbackIcon, ProfileIcon, ProfileFilledIcon, UserGroupIcon, MembershipIcon, CreditCardsIcon, PaymentListIcon, QuestionHelpIcon } from '@yoweb/ui/components/Icon';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { NavLarge } from './NavLarge';
import { NavSmall } from './NavSmall';
import { useTranslation } from '@yoweb/next-i18next';
import { PAGE_HOME, PAGE_ACCOUNT, PAGE_TODO, PAGE_SUBSCRIPTION, PAGE_PAYMENTS, PAGE_WALLET, PAGE_PROFILE, API_LOGOUT, PAGE_GUIDE, PAGE_HELP } from '@poplar/constants/routes';
import { URL_FAQ_PAGE } from '@poplar/constants/urls';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { TodosIcon } from './TodosIcon';
import { GuideCountIcon } from './GuideCountIcon';
import { logoutEvent } from '@yoweb/utils/analytics/mixpanel';
import { HelpFilledIcon } from '@yoweb/ui/components/Icon/HelpFilledIcon';
import HelpIcon from '@yoweb/ui/components/Icon/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AsyncFeedback = dynamic(function () {
  return import('@poplar/components/AsyncCore').then(function (mod) {
    return mod.Feedback;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@poplar/components/AsyncCore')];
    }
  }
});

var NavGlobal = function NavGlobal(_ref) {
  var pageLabel = _ref.pageLabel,
      mobileDisplay = _ref.mobileDisplay;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();

  var _useExternalConfig = useExternalConfig(),
      baseStoreUrl = _useExternalConfig.baseStoreUrl,
      mixpanel = _useExternalConfig.mixpanel,
      globalFeatures = _useExternalConfig.globalFeatures;

  var _useState = useState(false),
      isFeedbackModalOpen = _useState[0],
      setIsFeedbackModalOpen = _useState[1];

  var navItems = [{
    name: t('navGlobal.items.todos'),
    icon: /*#__PURE__*/_jsx(TodosIcon, {}),
    iconActive: /*#__PURE__*/_jsx(TodosIcon, {
      isActive: true
    }),
    url: PAGE_TODO,
    activePatterns: [new RegExp("^".concat(PAGE_TODO))],
    testId: 'nav-todos'
  }];
  var helpPage = globalFeatures !== null && globalFeatures !== void 0 && globalFeatures.enableGuideDeprecation ? PAGE_HELP : PAGE_GUIDE;
  navItems.push({
    name: t(globalFeatures !== null && globalFeatures !== void 0 && globalFeatures.enableGuideDeprecation ? 'navGlobal.items.help' : 'navGlobal.items.guide'),
    icon: globalFeatures !== null && globalFeatures !== void 0 && globalFeatures.enableGuideDeprecation ? /*#__PURE__*/_jsx(HelpIcon, {
      size: 24
    }) : /*#__PURE__*/_jsx(GuideCountIcon, {}),
    iconActive: globalFeatures !== null && globalFeatures !== void 0 && globalFeatures.enableGuideDeprecation ? /*#__PURE__*/_jsx(HelpFilledIcon, {
      size: 24
    }) : /*#__PURE__*/_jsx(GuideCountIcon, {
      isActive: true
    }),
    url: helpPage,
    activePatterns: [new RegExp("^".concat(helpPage, "$"))],
    testId: globalFeatures !== null && globalFeatures !== void 0 && globalFeatures.enableGuideDeprecation ? 'nav-help' : 'nav-guide'
  });
  navItems = [{
    name: t('navGlobal.items.home'),
    icon: /*#__PURE__*/_jsx(HomePageIcon, {
      size: 24
    }),
    iconActive: /*#__PURE__*/_jsx(HomePageFilledIcon, {
      size: 24
    }),
    url: PAGE_HOME,
    activePatterns: [new RegExp("^".concat(PAGE_HOME, "$"))],
    testId: 'nav-home'
  }].concat(_toConsumableArray(navItems), [{
    name: t('navGlobal.items.you'),
    icon: /*#__PURE__*/_jsx(ProfileIcon, {
      size: 24
    }),
    iconActive: /*#__PURE__*/_jsx(ProfileFilledIcon, {
      size: 24
    }),
    testId: 'nav-you',
    nested: [{
      name: t('navGlobal.items.profile'),
      url: PAGE_PROFILE,
      icon: /*#__PURE__*/_jsx(UserGroupIcon, {
        size: 24
      }),
      activePatterns: [new RegExp("^".concat(PAGE_PROFILE))],
      testId: 'nav-nested-profile'
    }, {
      name: t('navGlobal.items.account'),
      url: PAGE_ACCOUNT,
      icon: /*#__PURE__*/_jsx(ProfileIcon, {
        size: 24
      }),
      activePatterns: [new RegExp("^".concat(PAGE_ACCOUNT, "$"))],
      testId: 'nav-nested-account'
    }, {
      name: t('navGlobal.items.subscription'),
      url: PAGE_SUBSCRIPTION,
      icon: /*#__PURE__*/_jsx(MembershipIcon, {
        size: 24
      }),
      activePatterns: [new RegExp("^".concat(PAGE_SUBSCRIPTION))],
      testId: 'nav-nested-subscription'
    }, {
      name: t('navGlobal.items.payment-cards'),
      url: PAGE_WALLET,
      icon: /*#__PURE__*/_jsx(CreditCardsIcon, {
        size: 24
      }),
      activePatterns: [new RegExp("^".concat(PAGE_WALLET))],
      testId: 'nav-nested-payment-cards'
    }, {
      name: t('navGlobal.items.payment-history'),
      url: PAGE_PAYMENTS,
      icon: /*#__PURE__*/_jsx(PaymentListIcon, {
        size: 24
      }),
      activePatterns: [new RegExp("^".concat(PAGE_PAYMENTS))],
      testId: 'nav-nested-payment-history'
    }, {
      name: t('navGlobal.items.feedback'),
      icon: /*#__PURE__*/_jsx(FeedbackIcon, {
        size: 24
      }),
      action: function action() {
        return setIsFeedbackModalOpen(true);
      },
      testId: 'nav-nested-feedback'
    }, {
      name: t('navGlobal.items.faqs'),
      url: URL_FAQ_PAGE(baseStoreUrl),
      icon: /*#__PURE__*/_jsx(QuestionHelpIcon, {
        size: 24
      }),
      target: '_blank',
      testId: 'nav-nested-faqs'
    }, {
      name: t('sign-out'),
      largeOnly: true,
      testId: 'nav-nested-sign-out',
      prefetch: false,
      action: function action() {
        logoutEvent(mixpanel.domain);
        void router.push(API_LOGOUT);
      }
    }]
  }]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StickyRenderOnDesktop, {
      children: /*#__PURE__*/_jsx(NavLarge, {
        navItems: navItems
      })
    }), /*#__PURE__*/_jsx(RenderOn.MobileAndTablet, {
      display: mobileDisplay,
      children: /*#__PURE__*/_jsx(NavSmall, {
        navItems: navItems,
        pageLabel: pageLabel
      })
    }), /*#__PURE__*/_jsx(AsyncFeedback, {
      isOpen: isFeedbackModalOpen,
      setIsOpen: setIsFeedbackModalOpen
    })]
  });
};

var StickyRenderOnDesktop = styled(RenderOn.Desktop).withConfig({
  componentId: "sc-3m62y-0"
})(["position:sticky;top:0;"]);
export { NavGlobal };
export default NavGlobal;